module.exports = __webpack_public_path__ + "img/folder-red.e1bd244c.svg";